import React, {useState} from "react";
import {Card, Descriptions, Grid, Input, List, Skeleton, Tag} from "antd";
import {useFetch} from "hooks/useFetch";
import {useStore} from "hooks/useStore";
import {t} from "i18next";
import moment from "moment";

export const OnboardingCompanyCard = () => {
    const stores = useStore();
    const [companyRecall, setCompanyRecall] = useState(true);
    const [activity, setActivity] = useState("all");
    const companyName = stores?.meStore?.companies[0]?.name;

    const [companyLoading, companyData, setCompanyData, setCompanyLoading] = useFetch({
        defaultDataValue: {},
        fetchFn: stores.companyStore.getCompany.bind(null, {
            companyId: stores?.meStore?.companies[0]?._id,
            withSubCompanies: true
        }),
        condition: !!stores?.meStore?.companies[0]?._id,
        dependencies: [companyRecall, activity, stores?.meStore?.companies[0]?._id]
    });

    const companyInfo = [
        {
            title: t("fields.createdDate", {ns: "common"}),
            value: moment(companyData?.data?.createdAt).format("ll")
        },
        {title: "İl", value: companyData?.data?.city?.capitalize()},
        {title: t("fields.county", {ns: "common"}), value: companyData?.data?.county?.capitalize()},
        {title: t("fields.address", {ns: "common"}), value: companyData?.data?.address}
    ];

    return (
        <Card title={"Firma Bilgileri"} style={{minHeight: "100%"}}>
            <List
                grid={{
                    gutter: [16, 16],
                    xs: 1,
                    sm: 1,
                    md: 2,
                    lg: 2,
                    xl: 4,
                    xxl: 4
                }}
                dataSource={companyInfo}
                renderItem={row => (
                    <List.Item style={styles.listItem}>
                        <Skeleton loading={false} active>
                            <List.Item.Meta description={row.title} style={styles.listItemMeta} />
                            <Input value={row.value} disabled className="user-info-input" />
                        </Skeleton>
                    </List.Item>
                )}
                style={styles.list}
            />
        </Card>
    );
};

const styles = {
    list: {
        backgroundColor: "#fff",
        borderRadius: "4px"
    },
    listItem: {
        padding: "10px 0",
        borderBottom: "1px solid #f0f0f0",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch"
    },
    listItemMeta: {
        padding: "10px 0px",
        minWidth: "150px",
        fontWeight: "500",
        color: "#666",
        marginBottom: "8px"
    },
    listItemValue: {
        padding: "10px 20px",
        flex: 1,
        fontWeight: "400",
        color: "#333"
    }
};
